import FadeInView from '@/components/common/FadeInView';
import FilterCardsGrid from '@/components/common/FilterCardsGrid';
import { PersonCard } from '@/components/common/PersonCards';
import type { PersonCardsBlockProps } from './PersonCards.types';

const PersonCardsBlock = ({ items, listLabel = 'Person overview', filterSelect }: PersonCardsBlockProps) => {
	return (
		<FadeInView>
			<FilterCardsGrid listLabel={listLabel} filterSelect={filterSelect}>
				{items.map((item) => (
					<PersonCard key={item.id} {...item} />
				))}
			</FilterCardsGrid>
		</FadeInView>
	);
};

export default PersonCardsBlock;
